"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newExternalUserEpics = void 0;
const rxjs_1 = require("rxjs");
const redux_observable_1 = require("redux-observable");
const operators_1 = require("rxjs/operators");
const _epics = require("../../modules/newExternalUser/epics");
const addressBookActions = require("../../actions/order/addressBook");
const recipientsActions = require("../../actions/order/recipients");
const wizardActions = require("../../actions/order/wizard");
const epics = _epics.default('order');
function createHook(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === epics.ActionTypes.CREATE_NEW_SUCCESS), (0, operators_1.mergeMap)((action) => {
        const fol = action.payload.folder;
        return (0, rxjs_1.of)(addressBookActions.fetchRequest(fol), recipientsActions.fetchRequest({
            id: fol.project,
            uuid: fol.projectUuid
        }), wizardActions.step2AddRecipientAddNewDeliveryAddress(false));
    }));
}
exports.newExternalUserEpics = (0, redux_observable_1.combineEpics)(epics.create, createHook);
//# sourceMappingURL=newExternalUser.js.map